import React from 'react'
import CustomDatePicker from "../../containers/Common/CustomDatePicker";
import { PDF_DOWNLOAD, EXCEL_DOWNLOAD, REPORT_MODULES } from '../../App.config';
import DropdownComponent from "../../containers/Dropdown";
import * as utilities from "../../utilities/utils";
import { useState } from 'react';
import moment from 'moment';
import { useEffect } from 'react';
import { useForm, Controller } from "react-hook-form";

const ReportModalComponent = (props) => {
    const { register, control, handleSubmit, watch, formState: { errors }, setValue, getValues } = useForm();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [level, setLevel] = useState([]);
    const [levelItem, setLevelItem] = useState([]);
    const [selectedLevelName, setSelectedLevelName] = useState(null);
    const [error, setError] = useState({});
    const [lstLevelItems, setLstLevelItems] = useState([]);
    const [companyHasLevels, setCompanyHasLevels] = useState(false);
    const [regionId, setRegionId] = useState([]);
    const [deptId, setDeptId] = useState([]);

    useEffect(() => {
        if (!props.isOpen) {
            setFromDate(null);
            setToDate(null);
            setLevel([]);
            setLstLevelItems([]);
            setRegionId([]);
            setDeptId([]);
        }
    }, [props.isOpen]);

    useEffect(() => {
        let _error = {};
        if (fromDate) {
            _error['fromDate'] = "";
        }
        if (toDate) {
            _error['toDate'] = "";
        }
        setError(_error);
    }, [fromDate, toDate]);

    useEffect(() => {
        if (props.levelItems) {
            let allItem = { levelItemId: 0, levelItemName: "ALL " + selectedLevelName }
            setLstLevelItems([allItem, ...props.levelItems])
            setValue('selectedLevelItem', 0)
            setLevelItem([0]);
        }
    }, [props.levelItems])

    useEffect(() => {
        if (props.lstCompanyLevelData) {
            if (props.lstCompanyLevelData.length >= 8)
                setCompanyHasLevels(true);
            else
                setCompanyHasLevels(false);
        }
    }, [props.lstCompanyLevelData])

    const onLvlDropDownChange = (event) => {
        if (event.value > 0) {
            let leveNameItem = props.lstCompanyLevelData.find(x => x.levelNo == event.value)
            if (leveNameItem != null)
                setSelectedLevelName(leveNameItem.levelName)
        }
        setLevel(event.value);
        setValue('selectedLevel', utilities.extractFirstValueOfArray(event.value))
        if (event.value && event.value.length)
            props.onLevelSelect(utilities.extractFirstValueOfArray(event.value));
    }

    const handleRegionChange = (event) => {
        if (event.value && event.value.length)
            props.onRegionSelect(utilities.extractFirstValueOfArray(event.value));
        setRegionId(event.value);
        setValue('regionId', utilities.extractFirstValueOfArray(event.value))
    }

    const handleDeptChange = (event) => {
        setDeptId(event.value);
        setValue('deptId', utilities.extractFirstValueOfArray(event.value))
    }

    const onLvlItemDropDownChange = (event) => {
        setLevelItem(event.value);
        setValue('selectedLevelItem', utilities.extractFirstValueOfArray(event.value))
    }

    const onDownloadReportClick = (downloadType, moduleId, reportId, isDateRangeRequired, reportName) => {
        let _error = {};
        if (isDateRangeRequired) {
            if (!fromDate) {
                _error['fromDate'] = "Start date is required";
                setError(_error);
                return;
            }
            if (!toDate) {
                _error['toDate'] = "End date is required";
                setError(_error);
                return;
            }
        }

        let levelNo = getValues("selectedLevel");
        let levelItemId = getValues("selectedLevelItem");

        if (!companyHasLevels) {

            let regionId = getValues("regionId");
            let deptId = getValues("deptId");

            if (regionId > 0) {
                levelNo = 7
                levelItemId = regionId
            }
            if (deptId > 0) {
                levelNo = 8
                levelItemId = deptId
            }
        }

        if (downloadType == PDF_DOWNLOAD)
            props.onDownloadReportClick(PDF_DOWNLOAD, fromDate, toDate, moduleId, reportId, levelNo, levelItemId, reportName)
        else
            props.onDownloadReportClick(EXCEL_DOWNLOAD, fromDate, toDate, moduleId, reportId, levelNo, levelItemId, reportName)
        // props.onDownloadReportClick(PDF_DOWNLOAD, fromDate, toDate, props.selectedReport.moduleId, reportdetail.reportId)
    }

    const getHeaderTranslationText = (moduleId) => {
        switch (moduleId) {
            case REPORT_MODULES.STD: return "MyReports.Report.STD.Header";
                break
            case REPORT_MODULES.ACCM: return "MyReports.Report.ACCM.Header";
                break
            case REPORT_MODULES.CCM: return "MyReports.Report.CCM.Header";
                break
            case REPORT_MODULES.LTD: return "MyReports.Report.LTD.Header";
                break
            case REPORT_MODULES.WORKER_COMP: return "MyReports.Report.WORKER_COMP.Header";
                break
        }
    }

    return (
        <>
            {props.isOpen && <div
                className={props.isOpen ? "modal right fade report show md" : "modal right fade md"}
                id="modal1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-slideout" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title align-right" id="exampleModalLabel">
                                {props.context.t(
                                    getHeaderTranslationText(props.selectedReport.moduleId)
                                )}
                            </h5>
                            <button onClick={() => props.setIsOpen(false)} type="button" className="close noti" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body report-modal">
                            <div className='report-date'>
                                <div className='row'>
                                    <div className='col-6'>
                                        <label>{props.context.t(
                                            "MyReports.Page.Input.FromDate"
                                        )}</label>
                                        <CustomDatePicker

                                            id="fromDate"
                                            selected={fromDate}
                                            onChange={(date) => {
                                                setFromDate(date);
                                                if (!date)
                                                    setToDate(null);
                                            }}
                                            maxDate={moment().toDate()}
                                            // ref={state.dateOfBirth.ref}
                                            className="form-control"
                                            placeholderText={props.context.t(
                                                "MyReports.Page.Input.FromDate"
                                            )}
                                            placement={"bottom-end"}
                                        />
                                        {!fromDate && <span className='text-danger'>{error?.fromDate}</span>}
                                    </div>
                                    {/* {fromDate &&  */}
                                    <div className='col-6'>
                                        <label>{props.context.t(
                                            "MyReports.Page.Input.ToDate"
                                        )}</label>
                                        <CustomDatePicker
                                            id="toDate"
                                            selected={toDate}
                                            onChange={(date) => {
                                                setToDate(date);
                                            }}
                                            minDate={fromDate}
                                            maxDate={moment().toDate()}
                                            // ref={state.dateOfBirth.ref}
                                            className="form-control"
                                            placeholderText={props.context.t(
                                                "MyReports.Page.Input.ToDate"
                                            )}
                                        />
                                        {!toDate && <span className='text-danger'>{error?.toDate}</span>}
                                    </div>
                                    {/* } */}
                                </div>
                                {
                                    (props.selectedReport.moduleId != REPORT_MODULES.WORKER_COMP) ?
                                        (companyHasLevels) ?
                                            <div className='row my-3'>
                                                <div className='col-6'>
                                                    <label>{props.context.t(
                                                        "MyReports.Page.Input.OrgStructure.Label"
                                                    )}</label>
                                                    <Controller
                                                        {...register("selectedLevel", { required: true, value: getValues("selectedLevel") })}
                                                        render={({ field }) =>
                                                            <DropdownComponent
                                                                name="levelList"
                                                                options={props.lstCompanyLevelData}
                                                                isMultiSelect={false}
                                                                option_key="levelNo"
                                                                option_display="levelName"
                                                                onChange={onLvlDropDownChange}
                                                                values={level}
                                                                simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                                                selectAllText="Select All Options"
                                                                isSearchOption={true}
                                                                searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                                            />
                                                        }
                                                        name="selectedLevel"
                                                        control={control}
                                                    />
                                                </div>
                                                {(lstLevelItems && lstLevelItems.length > 0 && selectedLevelName) &&
                                                    <div className='col-6'>
                                                        <label>{selectedLevelName}</label>
                                                        <Controller
                                                            {...register("selectedLevelItem", { required: true, value: getValues("selectedLevelItem") })}
                                                            render={({ field }) =>
                                                                <DropdownComponent
                                                                    name="levelItemList"
                                                                    options={lstLevelItems}
                                                                    isMultiSelect={false}
                                                                    option_key="levelItemId"
                                                                    option_display="levelItemName"
                                                                    onChange={onLvlItemDropDownChange}
                                                                    values={levelItem}
                                                                    simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                                                    selectAllText="Select All Options"
                                                                    isSearchOption={true}
                                                                    searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                                                />
                                                            }
                                                            name="selectedLevelItem"
                                                            control={control}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                            :
                                            <div className='row my-3'>
                                                <div className='col-6'>
                                                    <label>{props.context.t(
                                                        "MyReports.Page.Input.Region.Label"
                                                    )}</label>
                                                    <Controller
                                                        {...register("regionId", { required: true, value: getValues("regionId") })}
                                                        render={({ field }) =>
                                                            <DropdownComponent
                                                                name="regionList"
                                                                options={props.regionList}
                                                                isMultiSelect={false}
                                                                option_key="coRegionID_PK"
                                                                option_display="regionName"
                                                                onChange={handleRegionChange}
                                                                values={regionId}
                                                                simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                                                selectAllText="Select All Options"
                                                                isSearchOption={true}
                                                                searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                                            />
                                                        }
                                                        name="selectedLevel"
                                                        control={control}
                                                    />
                                                </div>
                                                {
                                                    (props.departmentList && props.departmentList.length > 0)
                                                    &&
                                                    <div className='col-6'>
                                                        <label>{props.context.t(
                                                            "MyReports.Page.Input.Location.Label"
                                                        )}</label>
                                                        <Controller
                                                            {...register("deptId", { required: true, value: getValues("deptId") })}
                                                            render={({ field }) =>
                                                                <DropdownComponent
                                                                    name="departentList"
                                                                    options={props.departmentList}
                                                                    isMultiSelect={false}
                                                                    option_key="coLocationID_PK"
                                                                    option_display="externalID"
                                                                    onChange={handleDeptChange}
                                                                    values={deptId}
                                                                    simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                                                    selectAllText="Select All Options"
                                                                    isSearchOption={true}
                                                                    searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                                                />
                                                            }
                                                            name="selectedLevel"
                                                            control={control}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        : <></>
                                }
                            </div>

                            <div className="outer-box">

                                {props.selectedReport && Array.isArray(props.selectedReport.report) && props.selectedReport.report.map((reportdetail) =>
                                    <div className="inner-box">
                                        <div className="content">
                                            <span className="report-name">{reportdetail.reportName}</span>
                                            <span className="badge badge-report" onClick={() => onDownloadReportClick(PDF_DOWNLOAD, props.selectedReport.moduleId, reportdetail.reportId, reportdetail.isDateRangeRequired, reportdetail.reportName)}>PDF</span>
                                            <span className="badge badge-report" onClick={() => onDownloadReportClick(EXCEL_DOWNLOAD, props.selectedReport.moduleId, reportdetail.reportId, reportdetail.isDateRangeRequired, reportdetail.reportName)}>Excel</span>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                        {/* <div class="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => props.setIsOpen(false)}>Close</button>
                        </div> */}
                    </div>
                </div>
            </div>}
        </>
    );
};
export default ReportModalComponent;
